var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-12" },
      [
        _c(
          "b-form-group",
          { attrs: { label: "Destino" } },
          [
            _c("b-form-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              attrs: {
                "data-cy": "destination",
                "data-vv-as": "destino",
                name: "destination",
                type: "text",
                state: _vm.errors.has("custom-document-part-2.destination")
                  ? false
                  : null,
                maxLength: "150"
              },
              model: {
                value: _vm.destinationForm.destination,
                callback: function($$v) {
                  _vm.$set(_vm.destinationForm, "destination", $$v)
                },
                expression: "destinationForm.destination"
              }
            }),
            _vm.errors.has("custom-document-part-2.destination")
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger v-enter-to"
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.errors.first(
                              "custom-document-part-2.destination"
                            )
                          ) +
                          " "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._m(1),
        _c(
          "div",
          { staticClass: "col-md-3 text-center" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Hora" } },
              [
                _c("b-form-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: {
                        required: !!_vm.destinationForm.mileageOutput.length
                      },
                      expression:
                        "{ required: !!destinationForm.mileageOutput.length }"
                    }
                  ],
                  attrs: {
                    state: _vm.errors.has(
                      "custom-document-part-2.departureTime"
                    )
                      ? false
                      : null,
                    "data-cy": "departure-time",
                    "data-vv-as": "hora",
                    name: "departureTime",
                    type: "time"
                  },
                  model: {
                    value: _vm.destinationForm.departureTime,
                    callback: function($$v) {
                      _vm.$set(_vm.destinationForm, "departureTime", $$v)
                    },
                    expression: "destinationForm.departureTime"
                  }
                }),
                _vm.errors.has("custom-document-part-2.departureTime")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "text-left con-text-validation span-text-validation-danger v-enter-to"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first(
                                  "custom-document-part-2.departureTime"
                                )
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-3 text-center" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Kilometraje" } },
              [
                _c(
                  "b-input-group",
                  { attrs: { append: "KM" } },
                  [
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {
                            required: !!_vm.destinationForm.departureTime.length
                          },
                          expression:
                            "{ required: !!destinationForm.departureTime.length }"
                        }
                      ],
                      attrs: {
                        state: _vm.errors.has(
                          "custom-document-part-2.mileageOutput"
                        )
                          ? false
                          : null,
                        "data-cy": "mileage-output",
                        "data-vv-as": "km",
                        name: "mileageOutput",
                        type: "number",
                        formatter: _vm.maxLength
                      },
                      model: {
                        value: _vm.destinationForm.mileageOutput,
                        callback: function($$v) {
                          _vm.$set(_vm.destinationForm, "mileageOutput", $$v)
                        },
                        expression: "destinationForm.mileageOutput"
                      }
                    })
                  ],
                  1
                ),
                _vm.errors.has("custom-document-part-2.mileageOutput")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "text-left con-text-validation span-text-validation-danger v-enter-to"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first(
                                  "custom-document-part-2.mileageOutput"
                                )
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-3 text-center" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Hora" } },
              [
                _c("b-form-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: {
                        required: !!_vm.destinationForm.mileageArrival.length
                      },
                      expression:
                        "{ required: !!destinationForm.mileageArrival.length }"
                    }
                  ],
                  attrs: {
                    state: _vm.errors.has("custom-document-part-2.arrivalTime")
                      ? false
                      : null,
                    "data-cy": "arrival-time",
                    "data-vv-as": "hora",
                    name: "arrivalTime",
                    type: "time"
                  },
                  model: {
                    value: _vm.destinationForm.arrivalTime,
                    callback: function($$v) {
                      _vm.$set(_vm.destinationForm, "arrivalTime", $$v)
                    },
                    expression: "destinationForm.arrivalTime"
                  }
                }),
                _vm.errors.has("custom-document-part-2.arrivalTime")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "text-left con-text-validation span-text-validation-danger v-enter-to"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first(
                                  "custom-document-part-2.arrivalTime"
                                )
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-3 text-center" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Kilometraje" } },
              [
                _c(
                  "b-input-group",
                  { attrs: { append: "KM" } },
                  [
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {
                            required: !!_vm.destinationForm.arrivalTime.length
                          },
                          expression:
                            "{ required: !!destinationForm.arrivalTime.length }"
                        }
                      ],
                      attrs: {
                        state: _vm.errors.has(
                          "custom-document-part-2.arrivalTime"
                        )
                          ? false
                          : null,
                        "data-cy": "mileage-arrival",
                        "data-vv-as": "km",
                        name: "mileageArrival",
                        type: "number",
                        formatter: _vm.maxLength
                      },
                      model: {
                        value: _vm.destinationForm.mileageArrival,
                        callback: function($$v) {
                          _vm.$set(_vm.destinationForm, "mileageArrival", $$v)
                        },
                        expression: "destinationForm.mileageArrival"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm.errors.has("custom-document-part-2.mileageArrival")
              ? _c(
                  "div",
                  {
                    staticClass:
                      "text-left con-text-validation span-text-validation-danger v-enter-to"
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.errors.first(
                              "custom-document-part-2.mileageArrival"
                            )
                          ) +
                          " "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]),
    _c(
      "div",
      { staticClass: "col-md-12 d-flex align-items-end justify-content-end" },
      [
        _c(
          "b-button",
          {
            directives: [
              {
                name: "ripple",
                rawName: "v-ripple.400",
                value: "rgba(255, 255, 255, 0.15)",
                expression: "'rgba(255, 255, 255, 0.15)'",
                modifiers: { "400": true }
              }
            ],
            attrs: { "data-cy": "add-destination-button", variant: "primary" },
            on: {
              click: function($event) {
                return _vm.addDestination()
              }
            }
          },
          [_vm._v(" Agregar Destino ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 text-center" }, [
      _c("strong", [_vm._v("Salida")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 text-center" }, [
      _c("strong", [_vm._v("Llegada")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }